<template>
  <div>
    <LinkWrapper
      :href="prerollTargetUrl"
      v-if="!hideLink"
      target="_blank"
      @click="handleClickWithLink"
    >
      <img :src="prerollImage" class="preroll" alt="preroll image" />
    </LinkWrapper>

    <img
      v-else
      :src="prerollImage"
      :class="[classes.preroll, 'preroll']"
      alt="preroll image"
      @click="handleClick"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { injectPreroll, PrerollContext } from "../hooks/usePreroll";
import * as generateLinks from "@fresh8/ad-data-composition/src/lib/generateLinks";
import { injectBetData } from "@fresh8/ad-data-composition/src/betData";
import LinkWrapper from "./LinkWrapper.vue";
import { createUseStyles } from "@fresh8/vue-jss/src";
import { AnalyticEvents } from "@fresh8/types/src/analytics";
import { useHandleAnalytics } from "../lib/analytics";
import { useAnalytics } from "../hooks/useAnalytics";

const useStyles = createUseStyles({
  preroll: {
    cursor: "pointer"
  }
});

export default defineComponent({
  name: "Preroll",
  props: {
    sizeId: {
      type: String,
      required: true
    }
  },
  components: { LinkWrapper },
  setup() {
    const betData = injectBetData();
    const handleAnalytics = useHandleAnalytics();
    const analytics = useAnalytics({}, "Pre-roll");

    const {
      prerollImage,
      prerollTargetUrl: prerollUrl,
      usePreroll,
      prerollDuration
    } = injectPreroll() as PrerollContext;

    const classes = useStyles();

    const hideLink = computed(() => {
      if (usePreroll.value === true && prerollDuration?.value === 0) {
        return true;
      }
      return false;
    });

    const handleClickWithLink = () => {
      analytics.handleClick();
    };

    const handleClick = () => {
      handleAnalytics(AnalyticEvents.INTERACTED, "Pre-roll Dismissed");
    };

    // use registration url as the default if no target is set on the brand or adtag.
    const prerollTargetUrl = computed(() => {
      let url = betData?.links.value?.registration;

      // Find pre-roll targetUrl if set on the brand.
      let targetUrl = prerollUrl.value;
      // use customTargetUrl set on the adtag if set.
      if (
        betData?.prerollTargetUrl.value &&
        betData?.prerollTargetUrl.value !== ""
      ) {
        targetUrl = betData?.prerollTargetUrl.value;
      }

      if (targetUrl !== undefined && targetUrl !== "") {
        url = generateLinks.cta(targetUrl, {
          affiliateId: betData?.affiliateId?.value,
          clickUrl: betData?.clickUrl?.value,
          operatorKey: betData?.operator?.value?.name || ""
        });
      }

      return url;
    });

    return {
      handleClick,
      handleClickWithLink,
      prerollImage,
      prerollTargetUrl,
      hideLink,
      classes
    };
  }
});
</script>
